export const PO_TYPE = {
    PO_RECEIVED:'PO Received',
    DELIVERED:'Delivered'
}

export const PURCHASE_ORDER_STATUSES = [
    {
        inactive_icon:'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250428071659-Icon+%281%29.svg',
        active_icon:'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250428071659-Icon.svg',
        name:'Raw Materials',
        value:'RAW_MATERIAL'
    },
    {
        inactive_icon:'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250428071659-Icon+%283%29.svg',
        active_icon:'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250428071659-Icon+%282%29.svg',
        name:'Board Making',
        value:'BOARD_MAKING'
    },
    {
        inactive_icon:'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250428071659-Icon+%283%29.svg',
        active_icon:'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250428071659-Icon+%282%29.svg',
        name:'Cutting',
        value:'CUTTING'
    },
    {
        inactive_icon:'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250428074157-Icon.svg',
        active_icon:'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250428074157-Icon+%281%29.svg',
        name:'Printing',
        value:'PRINTING'
    },
    {
        inactive_icon:'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250428075340-Icon+%282%29.svg',
        active_icon:'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250428075340-Icon+%283%29.svg',
        name:'Loading',
        value:'LOADING'
    },
    {
        inactive_icon:'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250428075403-Icon+%285%29.svg',
        active_icon:'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250428075403-Icon+%284%29.svg',
        name:'Dispatch',
        value:'DISPATCH'
    },
]